import axios from 'axios'
import qs from 'query-string'

axios.defaults.timeout = 60000;
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 针对 x-www-form-urlencoded 对 object 进行序列化
const transformParams = (config, params) => {
  if (config && config.headers && config.headers['Content-Type'] === 'application/x-www-form-urlencoded;charset=UTF-8') {
    return qs.stringify(params);
  } else {
    return params
  }
}

const request =  (url, params, config, method) => {
  let sendParams = transformParams(config, params);
  return new Promise((resolve, reject) => {
    axios[method](url, sendParams, Object.assign({}, config)).then(response => {
      resolve(response.data)
    }, err => {
      if (err.Cancel) {
        console.log(err)
      } else {
        reject(err)
      }
    }).catch(err => {
      reject(err)
    })
  })
}

const post = (url, params, config = {}) => {
  return request(url, params, config, 'post')
}

const get = (url, params, config = {}) => {
  return request(url, params, config, 'get')
}

export { post, get }
